import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Crown, Lock, ShieldCheck } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { useTranslation, Trans } from 'react-i18next';

interface HiddenDataBannerProps {
  hiddenCount: number;
  itemLabel: string; // e.g. "articles", "maintenances", "checklists", "navires"
  className?: string;
}

const HiddenDataBanner = ({ hiddenCount, itemLabel, className = '' }: HiddenDataBannerProps) => {
  const { t } = useTranslation('dashboard');
  const navigate = useNavigate();

  if (hiddenCount <= 0) return null;

  return (
    <Alert className={`border-amber-300 bg-amber-50 ${className}`}>
      <Lock className="h-4 w-4 text-amber-600" />
      <AlertTitle className="text-amber-800 flex items-center gap-2">
        {t('premium.hiddenItems', { count: hiddenCount, itemLabel, plural: hiddenCount > 1 ? 's' : '' })}
      </AlertTitle>
      <AlertDescription className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
        <span className="flex-1 text-amber-700">
          <ShieldCheck className="h-4 w-4 inline mr-1 text-green-600" />
          <Trans t={t} i18nKey="premium.dataSafe" />
        </span>
        <Button 
          size="sm"
          onClick={() => navigate('/account')}
          className="bg-nautic-gold text-nautic hover:bg-nautic-lightgold whitespace-nowrap"
        >
          <Crown className="h-3 w-3 mr-1" />
          {t('premium.reactivate')}
        </Button>
      </AlertDescription>
    </Alert>
  );
};

export default HiddenDataBanner;
